var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.url)?_c('iframe',{ref:"mediaItem",class:_vm.classes,attrs:{"src":_vm.url,"frameborder":"0","height":`${_vm.$vuetify.breakpoint.height}px`,"width":`${(_vm.$vuetify.breakpoint.height * 16) / 9}px`},on:{"error":_vm.error}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }